module.exports = __webpack_public_path__ + "img/huodong.52e7260f.png";